import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const planesApi = createApi({
  reducerPath: "planesApi",
  baseQuery: baseQuery(`${API_SERVER}/planes`),
  tagTypes: ["planesCliente", "infoPlanCliente"],
  endpoints: (builder) => ({
    getPlan: builder.query({
      query: (id) => `/${id}`,
      providesTags: ["infoPlanCliente"],
    }),
    getPlanesPorEmpleado: builder.query({
      query: ({ sucursal, rut }) => `/empleado/${sucursal}/${rut}`,
    }),
    obtenerPlanesMasCotizados: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return { url: `/planesMasCotizados`, method: "GET", params };
      },
    }),
    obtenerContribuyentesPlanes: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return { url: `/contribuyentesPlanes`, method: "GET", params };
      },
    }),
    obtenerCantidadPromedioPlanesCliente: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return { url: "/cantidadPromedioPlanesCliente", method: "GET", params };
      },
    }),
    obtenerPlanesCliente: builder.query({
      query: (rutCliente) => `/planesCliente/${rutCliente}`,
    }),
    obtenerPlanesSegunCliente: builder.query({
      query: (rut) => `/cliente/${rut}`,
    }),
    actualizarDatosPlan: builder.mutation({
      query: (body) => ({
        url: `/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["infoPlanCliente"],
    }),
    obtenerPlanesAsociadosCliente: builder.query({
      query: (id) => `/relacionPlanCliente/${id}`,
      providesTags: ["planesCliente"],
    }),
    editarPlan: builder.mutation({
      query: (body) => ({
        url: "/relacionPlanCliente",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["planesCliente"],
    }),
    editarFacturacionGestor: builder.mutation({
      query: ({ refPlan, refTipoPlan, ...body }) => ({
        url: `/relacionPlanCliente/${refPlan}/${refTipoPlan}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["planesCliente"],
    }),
    eliminarPlan: builder.mutation({
      query: ({ refPlan, refTipoPlan }) => ({
        url: `/relacionPlanCliente/${refPlan}/${refTipoPlan}`,
        method: "DELETE",
      }),
      invalidatesTags: ["planesCliente"],
    }),
  }),
});

export const {
  useGetPlanQuery,
  useGetPlanesPorEmpleadoQuery,
  useObtenerPlanesClienteQuery,
  useObtenerContribuyentesPlanesQuery,
  useObtenerPlanesMasCotizadosQuery,
  useObtenerCantidadPromedioPlanesClienteQuery,
  useLazyObtenerPlanesClienteQuery,
  useLazyObtenerContribuyentesPlanesQuery,
  useLazyObtenerCantidadPromedioPlanesClienteQuery,
  useLazyObtenerPlanesMasCotizadosQuery,
  useActualizarDatosPlanMutation,
  useObtenerPlanesAsociadosClienteQuery,
  useEditarPlanMutation,
  useEliminarPlanMutation,
  useEditarFacturacionGestorMutation,
  useLazyObtenerPlanesAsociadosClienteQuery,
  useLazyGetPlanQuery,
  useObtenerPlanesSegunClienteQuery,
} = planesApi;
